import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MobileOutlined } from '@ant-design/icons';

// DS
import {
  Col,
  VertTypography,
  VertIcon,
  VertModal,
  VertButton,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Modal/ModalTermOfUseStyles.less';
import { currencyMask } from 'Utils/commons/mask';
import Regulation from 'components/Regulation';

const REGULATION_TYPE_CAMPAIGN = 'Campaign';
const REGULATION_TYPE_CAMPAIGN_AND_VENDOR = 'VendorAndRegulationType';
const REGULATION_TYPE_VENDOR = 'Vendor';

// MODAL CONFIRM PHONE RECHARGE COMPONENT
const ModalTermOfUse = ({ ...props }) => {
  const {
    open,
    acceptTerms,
    cancelTerm,
    onStateModal,
    terms,
    title,
    isLoading,
  } = props;

  const openModalHandle = () => {
    onStateModal(!open);
  };

  const afterClose = () => {
    openModalHandle();
  };

  return (
    <VertModal
      key={'ModalTermOfUse'}
      open={open}
      className="modal-terms-of-use"
      onCancel={openModalHandle}
      afterClose={afterClose}
      width={560}
    >
      <div className="modal-terms-of-use-content">
        <VertTypography.Paragraph className="title">
          {title}
        </VertTypography.Paragraph>
        <Col className="modal-terms-of-use-regulation">
          <Regulation
            regulationType={terms.regulationType}
            vendorId={terms.vendorId}
          />
        </Col>

        <Col className="modal-terms-of-use-buttons-container">
          <VertButton
            className="confirm-button"
            type="highlight"
            onClick={() => acceptTerms()}
            spacing="small"
          >
            Li e aceito o termos de uso
          </VertButton>
        </Col>
      </div>
    </VertModal>
  );
};

{
  /* <ModalServices
title={'Termos do Regulamento de Shell Box'}
show={showModal}
onClose={closeterms}
acceptTerms={e => acceptTermsEvent(true)}
terms={{
  vendorId: shellSupplierId,
  type: regulationType
}}
isLoading={sendRedemption}
/> */
}

ModalTermOfUse.propTypes = {
  open: PropTypes.bool,
  acceptTerms: PropTypes.func,
  cancelTerm: PropTypes.func,
  onStateModal: PropTypes.func,
  terms: PropTypes.shape({
    vendorId: PropTypes.number, //shellSuplierId
    type: PropTypes.string, //      regulationType: 'Vendor',
  }),
  title: PropTypes.string,
  isLoading: PropTypes.bool,
};


export default ModalTermOfUse;
